webpackJsonp([26,116,117,118,119,277],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isImageModalActive: false,
            isCardModalActive: false
        };
    }
});

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isImageModalActive = true
      }
    }
  }, [_vm._v("\n            Launch image modal\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isCardModalActive = true
      }
    }
  }, [_vm._v("\n            Launch card modal (keep scroll)\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isImageModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isImageModalActive = $event
      }
    }
  }, [_c('p', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png"
    }
  })])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isCardModalActive,
      "width": 640,
      "scroll": "keep"
    },
    on: {
      "update:active": function($event) {
        _vm.isCardModalActive = $event
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("John Smith")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("@johnsmith")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                        Phasellus nec iaculis mauris. "), _c('a', [_vm._v("@bulmaio")]), _vm._v(".\n                        "), _c('a', [_vm._v("#css")]), _vm._v(" "), _c('a', [_vm._v("#responsive")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("11:09 PM - 1 Jan 2016")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ModalForm = {
    props: ['email', 'password'],
    template: '\n            <form action="">\n                <div class="modal-card" style="width: auto">\n                    <header class="modal-card-head">\n                        <p class="modal-card-title">Login</p>\n                    </header>\n                    <section class="modal-card-body">\n                        <b-field label="Email">\n                            <b-input\n                                type="email"\n                                :value="email"\n                                placeholder="Your email"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-field label="Password">\n                            <b-input\n                                type="password"\n                                :value="password"\n                                password-reveal\n                                placeholder="Your password"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-checkbox>Remember me</b-checkbox>\n                    </section>\n                    <footer class="modal-card-foot">\n                        <button class="button" type="button" @click="$parent.close()">Close</button>\n                        <button class="button is-primary">Login</button>\n                    </footer>\n                </div>\n            </form>\n        '
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ModalForm: ModalForm
    },
    data: function data() {
        return {
            isComponentModalActive: false,
            formProps: {
                email: 'evan@you.com',
                password: 'testing'
            }
        };
    }
});

/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = true
      }
    }
  }, [_vm._v("\n            Launch component modal\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": "",
      "trap-focus": "",
      "aria-role": "dialog",
      "aria-modal": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('modal-form', _vm._b({}, 'modal-form', _vm.formProps, false))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var ModalForm = {
    props: ['email', 'password'],
    template: '\n            <form action="">\n                <div class="modal-card" style="width: auto">\n                    <header class="modal-card-head">\n                        <p class="modal-card-title">Login</p>\n                    </header>\n                    <section class="modal-card-body">\n                        <b-field label="Email">\n                            <b-input\n                                type="email"\n                                :value="email"\n                                placeholder="Your email"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-field label="Password">\n                            <b-input\n                                type="password"\n                                :value="password"\n                                password-reveal\n                                placeholder="Your password"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-checkbox>Remember me</b-checkbox>\n                    </section>\n                    <footer class="modal-card-foot">\n                        <button class="button" type="button" @click="$parent.close()">Close</button>\n                        <button class="button is-primary">Login</button>\n                    </footer>\n                </div>\n            </form>\n        '
};

/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        imageModal: function imageModal() {
            this.$buefy.modal.open('<p class="image is-4by3">\n                        <img src="https://buefy.org/static/img/placeholder-1280x960.png">\n                    </p>');
        },
        cardModal: function cardModal() {
            this.$buefy.modal.open({
                parent: this,
                component: ModalForm,
                hasModalCard: true,
                customClass: 'custom-class custom-class-2',
                trapFocus: true
            });
        }
    }
});

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.imageModal()
      }
    }
  }, [_vm._v("\n            Launch image modal (HTML)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.cardModal()
      }
    }
  }, [_vm._v("\n            Launch card modal (Component)\n        ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ModalForm = {
    props: ['email', 'password'],
    template: '\n            <div class="modal-card" style="width: auto">\n                <header class="modal-card-head">\n                    <p class="modal-card-title">Login</p>\n                </header>\n                <section class="modal-card-body">\n                    <b-field label="Email">\n                        <b-input\n                            type="email"\n                            :value="email"\n                            placeholder="Your email"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-field label="Password">\n                        <b-input\n                            type="password"\n                            :value="password"\n                            password-reveal\n                            placeholder="Your password"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-checkbox>Remember me</b-checkbox>\n                </section>\n                <footer class="modal-card-foot">\n                    <button class="button" type="button" @click="$parent.close()">Close</button>\n                    <button class="button is-primary">Login</button>\n                </footer>\n            </div>\n        '
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ModalForm: ModalForm
    },
    data: function data() {
        return {
            isComponentModalActive: false,
            formProps: {
                email: 'evan@you.com',
                password: 'testing'
            }
        };
    }
});

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = true
      }
    }
  }, [_vm._v("\n            Launch component modal\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": "",
      "full-screen": "",
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('modal-form', _vm._b({}, 'modal-form', _vm.formProps, false))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_modal__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExComponent__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExComponent__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExProgrammatic__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExProgrammatic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExProgrammatic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExProgrammatic__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExProgrammatic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExProgrammatic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExFullScreen__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExFullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExFullScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFullScreen__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFullScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFullScreen__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_modal__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExComponent: __WEBPACK_IMPORTED_MODULE_3__examples_ExComponent___default.a,
            ExProgrammatic: __WEBPACK_IMPORTED_MODULE_5__examples_ExProgrammatic___default.a,
            ExFullScreen: __WEBPACK_IMPORTED_MODULE_7__examples_ExFullScreen___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExComponentCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExComponent___default.a,
            ExProgrammaticCode: __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExProgrammatic___default.a,
            ExFullScreenCode: __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFullScreen___default.a,
            programmaticSyntax: '\n                // From inside Vue instance\n                this.$buefy.modal.open(props)\n\n                // From outside Vue instance\n                import { ModalProgrammatic as Modal } from \'buefy\'\n                Modal.open(props)'
        };
    }
});

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button is-primary is-medium\"\n            @click=\"isImageModalActive = true\">\n            Launch image modal\n        </button>\n        <button class=\"button is-primary is-medium\"\n            @click=\"isCardModalActive = true\">\n            Launch card modal (keep scroll)\n        </button>\n\n        <b-modal :active.sync=\"isImageModalActive\">\n            <p class=\"image is-4by3\">\n                <img src=\"/static/img/placeholder-1280x960.png\">\n            </p>\n        </b-modal>\n\n        <b-modal :active.sync=\"isCardModalActive\" :width=\"640\" scroll=\"keep\">\n            <div class=\"card\">\n                <div class=\"card-image\">\n                    <figure class=\"image is-4by3\">\n                        <img src=\"/static/img/placeholder-1280x960.png\" alt=\"Image\">\n                    </figure>\n                </div>\n                <div class=\"card-content\">\n                    <div class=\"media\">\n                        <div class=\"media-left\">\n                            <figure class=\"image is-48x48\">\n                                <img src=\"/static/img/placeholder-1280x960.png\" alt=\"Image\">\n                            </figure>\n                        </div>\n                        <div class=\"media-content\">\n                            <p class=\"title is-4\">John Smith</p>\n                            <p class=\"subtitle is-6\">@johnsmith</p>\n                        </div>\n                    </div>\n\n                    <div class=\"content\">\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                        Phasellus nec iaculis mauris. <a>@bulmaio</a>.\n                        <a>#css</a> <a>#responsive</a>\n                        <br>\n                        <small>11:09 PM - 1 Jan 2016</small>\n                    </div>\n                </div>\n            </div>\n        </b-modal>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isImageModalActive: false,\n                isCardModalActive: false\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1437:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button is-primary is-medium\"\n            @click=\"isComponentModalActive = true\">\n            Launch component modal\n        </button>\n\n        <b-modal :active.sync=\"isComponentModalActive\"\n                 has-modal-card\n                 trap-focus\n                 aria-role=\"dialog\"\n                 aria-modal>\n            <modal-form v-bind=\"formProps\"></modal-form>\n        </b-modal>\n    </section>\n</template>\n\n<script>\n    const ModalForm = {\n        props: ['email', 'password'],\n        template: `\n            <form action=\"\">\n                <div class=\"modal-card\" style=\"width: auto\">\n                    <header class=\"modal-card-head\">\n                        <p class=\"modal-card-title\">Login</p>\n                    </header>\n                    <section class=\"modal-card-body\">\n                        <b-field label=\"Email\">\n                            <b-input\n                                type=\"email\"\n                                :value=\"email\"\n                                placeholder=\"Your email\"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-field label=\"Password\">\n                            <b-input\n                                type=\"password\"\n                                :value=\"password\"\n                                password-reveal\n                                placeholder=\"Your password\"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-checkbox>Remember me</b-checkbox>\n                    </section>\n                    <footer class=\"modal-card-foot\">\n                        <button class=\"button\" type=\"button\" @click=\"$parent.close()\">Close</button>\n                        <button class=\"button is-primary\">Login</button>\n                    </footer>\n                </div>\n            </form>\n        `\n    }\n\n    export default {\n        components: {\n            ModalForm\n        },\n        data() {\n            return {\n                isComponentModalActive: false,\n                formProps: {\n                    email: 'evan@you.com',\n                    password: 'testing'\n                }\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1438:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button is-primary is-medium\"\n            @click=\"imageModal()\">\n            Launch image modal (HTML)\n        </button>\n        <button class=\"button is-primary is-medium\"\n            @click=\"cardModal()\">\n            Launch card modal (Component)\n        </button>\n    </section>\n</template>\n\n<script>\n    const ModalForm = {\n        props: ['email', 'password'],\n        template: `\n            <form action=\"\">\n                <div class=\"modal-card\" style=\"width: auto\">\n                    <header class=\"modal-card-head\">\n                        <p class=\"modal-card-title\">Login</p>\n                    </header>\n                    <section class=\"modal-card-body\">\n                        <b-field label=\"Email\">\n                            <b-input\n                                type=\"email\"\n                                :value=\"email\"\n                                placeholder=\"Your email\"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-field label=\"Password\">\n                            <b-input\n                                type=\"password\"\n                                :value=\"password\"\n                                password-reveal\n                                placeholder=\"Your password\"\n                                required>\n                            </b-input>\n                        </b-field>\n\n                        <b-checkbox>Remember me</b-checkbox>\n                    </section>\n                    <footer class=\"modal-card-foot\">\n                        <button class=\"button\" type=\"button\" @click=\"$parent.close()\">Close</button>\n                        <button class=\"button is-primary\">Login</button>\n                    </footer>\n                </div>\n            </form>\n        `\n    }\n\n    export default {\n        methods: {\n            imageModal() {\n                this.$buefy.modal.open(\n                    `<p class=\"image is-4by3\">\n                        <img src=\"https://buefy.org/static/img/placeholder-1280x960.png\">\n                    </p>`\n                )\n            },\n            cardModal() {\n                this.$buefy.modal.open({\n                    parent: this,\n                    component: ModalForm,\n                    hasModalCard: true,\n                    customClass: 'custom-class custom-class-2',\n                    trapFocus: true\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button is-primary is-medium\"\n            @click=\"isComponentModalActive = true\">\n            Launch component modal\n        </button>\n\n        <b-modal :active.sync=\"isComponentModalActive\"\n            has-modal-card full-screen :can-cancel=\"false\">\n            <modal-form v-bind=\"formProps\"></modal-form>\n        </b-modal>\n    </section>\n</template>\n\n<script>\n    const ModalForm = {\n        props: ['email', 'password'],\n        template: `\n            <div class=\"modal-card\" style=\"width: auto\">\n                <header class=\"modal-card-head\">\n                    <p class=\"modal-card-title\">Login</p>\n                </header>\n                <section class=\"modal-card-body\">\n                    <b-field label=\"Email\">\n                        <b-input\n                            type=\"email\"\n                            :value=\"email\"\n                            placeholder=\"Your email\"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-field label=\"Password\">\n                        <b-input\n                            type=\"password\"\n                            :value=\"password\"\n                            password-reveal\n                            placeholder=\"Your password\"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-checkbox>Remember me</b-checkbox>\n                </section>\n                <footer class=\"modal-card-foot\">\n                    <button class=\"button\" type=\"button\" @click=\"$parent.close()\">Close</button>\n                    <button class=\"button is-primary\">Login</button>\n                </footer>\n            </div>\n        `\n    }\n\n    export default {\n        components: {\n            ModalForm\n        },\n        data() {\n            return {\n                isComponentModalActive: false,\n                formProps: {\n                    email: 'evan@you.com',\n                    password: 'testing'\n                }\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1440:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExComponent,
      "code": _vm.ExComponentCode,
      "title": "Component"
    }
  }, [_c('p', [_vm._v("\n                A modal with a component. When you want to close the Modal, call the 'close' method —\n                "), _c('code', [_vm._v("this.$parent.close()")]), _vm._v(" — from the injected component.\n            ")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("trap-focus")]), _vm._v(" prop could be useful in this case.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExProgrammatic,
      "code": _vm.ExProgrammaticCode,
      "title": "Programmatic"
    }
  }, [_c('p', [_vm._v("Syntax:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "lang": "javascript",
      "code": _vm._f("pre")(_vm.programmaticSyntax),
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFullScreen,
      "code": _vm.ExFullScreenCode,
      "title": "Full Screen"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.8")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("full-screen")]), _vm._v(" prop to cover the whole page.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>active</code>',
        description: 'Whether modal is active or not, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>component</code>',
        description: 'Component to be injected, used to open a component modal programmatically.\n                    Close modal within the component by emitting a \'close\' event \u2014 <code>this.$emit(\'close\')</code>',
        type: 'Object, Function',
        values: '—',
        default: '—'
    }, {
        name: '<code>parent</code>',
        description: 'Parent component of the modal, <strong>required</strong> if using <code>component</code>',
        type: 'Vue',
        values: '—',
        default: '—'
    }, {
        name: '<code>props</code>',
        description: 'Props to be binded to the injected component',
        type: 'Object',
        values: '—',
        default: '—'
    }, {
        name: '<code>events</code>',
        description: 'Events to be binded to the injected component',
        type: 'Object',
        values: '—',
        default: '—'
    }, {
        name: '<code>content</code>',
        description: 'HTML content',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>width</code>',
        description: 'Width of the Modal',
        type: 'Number, String',
        values: '—',
        default: '<code>960</code>'
    }, {
        name: '<code>full-screen</code>',
        description: 'Display modal as full screen',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>has-modal-card</code>',
        description: 'If your modal content has a <code>.modal-card</code> as root, add this prop or the card might break on mobile',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>animation</code>',
        description: 'Custom animation (transition name)',
        type: 'String',
        values: '—',
        default: '<code>zoom-out</code>'
    }, {
        name: '<code>can-cancel</code>',
        description: 'Can close Modal by clicking \'X\', pressing escape or clicking outside',
        type: 'Boolean, Array',
        values: '<code>escape</code>, <code>x</code>, <code>outside</code>',
        default: '<code>[\'escape\', \'x\', \'outside\']</code>'
    }, {
        name: '<code>on-cancel</code>',
        description: 'Callback function to call after user canceled (clicked \'X\' / pressed escape / clicked outside)',
        type: 'Function',
        values: '—',
        default: '—'
    }, {
        name: '<code>scroll</code>',
        description: '<code>clip</code> to remove the <code>&lt;body&gt;</code> scrollbar, <code>keep</code> to have a non scrollable scrollbar\n                    to avoid shifting background, but will set <code>&lt;body&gt;</code> to position fixed, might break some layouts',
        type: 'String',
        values: '<code>clip</code>, <code>keep</code>',
        default: '<code>clip</code>'
    }, {
        name: '<code>trap-focus</code>',
        description: 'Trap focus inside the modal.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>custom-class</code>',
        description: 'CSS classes to be applied on modal',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-role</code>',
        description: 'Role attribute to be passed to modal container for better accessibility.',
        type: 'String',
        values: '<code>dialog</code>, <code>alertdialog</code>',
        default: '—'
    }, {
        name: '<code>aria-modal</code>',
        description: 'Improve accessiblity when enabled.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }],
    events: [{
        name: '<code>close</code>',
        description: 'Triggers when user closed/canceled or called programmatically from the injected component',
        parameters: '—'
    }]
}]);

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(1121),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1122),
  /* template */
  __webpack_require__(1123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1124),
  /* template */
  __webpack_require__(1125),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1126),
  /* template */
  __webpack_require__(1127),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1435),
  /* template */
  __webpack_require__(1440),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/26.068e7163e513a7429944.js